import { RootState } from '../../../../rootReducer';

export const unitTemplateSelector = (state: RootState) => state.templatesModuleReducer.UnitTemplateReducer;
